import { Component, Input } from '@angular/core';
import { concat, Subject, toArray } from 'rxjs';
import { IPolicyDetail } from 'src/app/modules/shared/models/policy.model';
import { PolicyService } from '../../policy.service';

@Component({
  selector: 'app-policy-switch',
  templateUrl: './policy-switch.component.html',
  styleUrl: './policy-switch.component.scss',
})
export class PolicySwitchComponent {
  @Input() detail: IPolicyDetail;
  destroy$ = new Subject<void>();
  swaitchDetails: any[];

  constructor(private _policyService: PolicyService) {}

  ngOnInit() {
    this.getFondo();
  }

  getFondo(): void {
    const foundsToFind =
      this.detail.intesaFurtherDetails.uni30.switchHistory.reduce(
        (acc, { originFund, destinationFund }) => {
          acc.push(originFund, destinationFund);
          return acc;
        },
        [] as string[]
      );

    const observables = foundsToFind.map((fund) =>
      this._policyService.getFondo(
        this.detail.policyExtraInfo.contractNumber,
        fund
      )
    );
    concat(...observables)
      .pipe(toArray())
      .subscribe((responses) => {
        this.swaitchDetails =
          this.detail.intesaFurtherDetails.uni30.switchHistory.map(
            (switchDetail) => {
              const originFundDetail = responses.find(
                (response) => response.cFondo === switchDetail.originFund
              );
              const destinationFundDetail = responses.find(
                (response) => response.cFondo === switchDetail.destinationFund
              );
              return {
                effectDate: switchDetail.effectDate,
                originFund: originFundDetail.descrizione?.trim(),
                destinationFund: destinationFundDetail.descrizione?.trim(),
                percentage: switchDetail.percentage,
              };
            }
          );
      });
  }
}
